$(document).ready(function(){
	//new mouse move
/*
	var timer;
	var refresh_time = 500;
	var x = 0;
	$('body').mousemove(function(evt) {
	  if (timer)
	    clearTimeout(timer);
	    timer = setTimeout(function(){
	      var mouse_x = evt.clientX;
	      if(mouse_x != x){
	        x = mouse_x;
	        console.log('mouse is on a new x position' + x);    
	      }
	    }, refresh_time);
	})
*/
	////////////////////////////////////////////
	// SETTING
	refresh_sec = 300;

	// FIRST RUN
	groupNailExist = $('#group-nail').length;
	groupFirstRun = true;
	if(groupNailExist){
		setGroupCustomer(2, function(){
			setSaleButton();
		});
	}else{
		groupExist = $('#group').length;
		if(groupExist){
			val_before = $('select[name=total_customer]').val();

			// FIRST SET
			if(!val_before){
				customer = 1; // เพราะสาขาใช้แต่ 1
				setGroupCustomer(customer, function(){
					$('select[name=total_customer]').val(customer);
					setSaleButton();
				});
			}
			
			$('select[name=total_customer]').change(function(){
				//second select
				if(confirm("การเลือกจำนวนลูกค้าใหม่จะทำให้สิ่งที่เลือกไว้หายทั้งหมด ยืนยัน?")){
					clearWizard();
					$('button[name=submit_button]').prop('disabled', false);
					
					customer = $(this).val();
					setGroupCustomer(customer);
					return true;
				}else{
					$('select[name=total_customer]').val(val_before);
					return false;

				}
			});
		}
	}
	
	function setGroupCustomer(customer, callback){
		// console.log('setGroupCustomer');
		var pass = true;
		
		if(pass){
			loading();
			$.ajax({
				type		:	"POST",
				url		:	"ajax_group.php",
				data		:	{command: "getCustomerInput", total: customer},
				success	:	function(data){
					unload();
					$('.dropzone').html(data);
					setGroupButtonTreatment();
					setGroupButtonPackage();
					if(customer > 0 && callback){
						callback();
					}
					$('#group_form button.default').click(function(){
						loading();
						//get default element
						i = 1;
						t = 1;
						p = 1;
						var parameter = '';
						total_customer = $('.group_customer').length;
						total = $('.customer1 .customer_drop_zone .item_group').length;
						$('.customer1 .customer_drop_zone .item_group').each(function(){
							treatment_exist = $(this).find('.treatment_select').length;
							if(treatment_exist){
								//tvar = "treatment["+t+"]="+$(this).find('.treatment_select').val();
								tvar = "select["+i+"][type]=treatment&select["+i+"][val]="+$(this).find('.treatment_select').val();
								//$('#first').append(tvar);
								parameter = parameter+tvar;
								t++;
							}
							
							package_exist = $(this).find('.package_select').length;
							if(package_exist){
								//pvar = "package["+p+"]="+$(this).find('.package_select').val();
								pvar = "select["+i+"][type]=package&select["+i+"][val]="+$(this).find('.package_select').val();
								//$('#first').append(pvar);
								parameter = parameter+pvar;
								p++;
							}
							if(i < total){
								parameter = parameter+"&";
								i++;
							}
						});
						
						//load select
						$.ajax({
							type	:	"POST",
							url		:	"ajax_group.php",
							dataType:	"json",
							data	:	{command: "doDefaultSelect", total_customer: total_customer, parameter: parameter},
							success	:	function(data){
								//$('#first').html(data);
								unload();
								i = 1;
								$('.customer_drop_zone').each(function(){
									$(this).html(data[i]);
									i++;
								});
								$('.package_detail').fadeIn();
								
								//auto complete therapist : treatment
								$('.customer_drop_zone .treatment_group .auto_employee').autocomplete({
									source: path+"ajax_autocomplete.php?type=all",
									minLength: 1,
									autoFocus: true
								});
								
								//auto complete therapist : package
								$('.customer_drop_zone  .package_group .auto_employee').autocomplete({
									source: path+"ajax_autocomplete.php?type=all",
									minLength: 1,
									autoFocus: true,
									close:	function(){
										sub_index = $(this).attr("sub_index");
										therapist_amount = parseInt($(this).attr('therapist'));
										if(therapist_amount > 1){
											child_index = $(this).parent().parent().index();
										}else{
											child_index = $(this).parent().parent().parent().parent().index();
										}
										if(child_index == 0){
											val = $(this).val();
											if(sub_index == 1){
												if(therapist_amount > 1){
													$(this).parent().parent().parent().parent().parent().find('.auto_employee').filter('[index_type=odd]').val(val);
												}else{
													$(this).parent().parent().parent().parent().parent().find('.auto_employee').not(':eq(0)').val(val);
												}
											}else{
											}
										}
									},
									select:	function(event, ui){
										$(this).parent().parent().parent().parent().parent().find('.reserve_therapist .reserve_checkbox').val(ui.item.value);
									}
								});
								
								//////////select
								$('.customer_drop_zone .package_select').change(function(){
									loading();
									obj = $(this);
									package_detail = obj.parent().parent().parent().parent().parent().find('.package_detail');
									product_id = $(this).val();
									index_id = $(this).attr('index');
									
									$.ajax({
										type	:	"POST",
										url		:	path+"ajax_group.php",
										data	:	{command: "getGroupPackageDetail", customer: customer, product_id: product_id, index_id: index_id},
										success	:	function(data){
											unload();
											package_detail.html(data).fadeIn();
											package_detail.find('.auto_employee').autocomplete({
												source: path+"ajax_autocomplete.php?type=all",
												minLength: 1,
												autoFocus: true,
												close:	function(){
													sub_index = $(this).attr("sub_index");
													therapist_amount = parseInt($(this).attr('therapist'));
													if(therapist_amount > 1){
														child_index = $(this).parent().parent().index();
													}else{
														child_index = $(this).parent().parent().parent().parent().index();
													}
													if(child_index == 0){
														val = $(this).val();
														if(sub_index == 1){
															if(therapist_amount > 1){
																$(this).parent().parent().parent().parent().parent().find('.auto_employee').filter('[index_type=odd]').val(val);
															}else{
																$(this).parent().parent().parent().parent().parent().find('.auto_employee').not(':eq(0)').val(val);
															}
														}else{
														}
													}
												},
												select:	function(event, ui){
													$(this).parent().parent().parent().parent().parent().find('.reserve_therapist .reserve_checkbox').val(ui.item.value);
												}
											});
										}
									});
								});
								//////////

								$('.customer_drop_zone .button.remove').click(function(){
									
									to_delete = $(this).parent().parent(); //for treatment
									if(to_delete.hasClass('treatment_group')){
										type = "treatment";
									}else{
										type = "package";
										to_delete = $(this).parent().parent().parent();
									}

									if(confirm(confirm_delete)){
										to_delete.remove();
										//realtimeCalculation();
									}
								});
							}
						});
						//load select
					});
				}
			});
		}

		if(groupFirstRun){
			// console.log('groupFirstRun '+groupFirstRun);
			val_before = $('select[name=total_customer]').val();
			$('select[name=total_customer]').change(function(){
				customer = $(this).val();
				setGroupCustomer(customer);
			});
			
			$('#group_form button.wizard').click(function(){
				/* wizard */
				total_item = $('.item_group').length;
				if(total_item > 0){
					$.ajax({
						type	:	"POST",
						url		:	"ajax.php",
						data	:	{command: "clearSkipAll"},
						success	:	function(data){
							//check input
							empty = false;
							$('.treatment_select').each(function(){
								if($(this).val() == ""){
									empty = true;
								}
							});
							$('.package_select').each(function(){
								if($(this).val() == ""){
									empty = true;
								}
							});
							if(empty){
								alert("Please select treatment/package for all customer.");
								return false;
							}else{
								//$('.dropzone').fadeTo(200, 0.2).addClass('disable');
								$('.dropzone').fadeOut().addClass('disable');
								$('.wizardzone').html('').fadeIn(200).addClass('loading black');
								wizardGroupSuccess();
							}
						}
					});
				}
			});
		
		
			$('#group_form button.submit_order').click(function(){
				// console.log('submit_order');
				//checkTherapistCode();
				//has wizard
				has_wizard = $('.wizardzone').html();
				
				if(has_wizard != ''){
					//has wizard
					vars = $('#group_form').serialize();
					//console.log(vars);
					$.ajax({
						type	:	"POST",
						url		:	"ajax_new.php",
						data 	:	{command: "checkgrouporder", vars: vars},
						dataType:	"json",
						error	:	function(data){
							console.log(data);	
						},
						success	:	function(data){
							//$('#first').html(data);
							// console.log(data);
							if(data.pass){
								if(confirm("Complete the reservation?")){
									$('#group_form').submit();
									return true;
								}else{
									return false;
								}
							}else{
								if(data.command == "autowizard"){
									if(confirm(data.message)){
										$('.dropzone').fadeOut().addClass('disable');
										$('.wizardzone').html('').fadeIn(200).addClass('loading black');
										wizardGroupSuccess();
										return false;
									}else{
										return false;
									}
								}else{
									alert(data.message);
									return false;
								}
							}
						}
					});
					return false;
				}else{
					//manual
					therapist_empty = false;
					$('.auto_employee').each(function(){
						if($(this).val() == ""){
							therapist_empty = true;
						}
					});
					if(therapist_empty){
						alert("Please don't leave the therapist fields blank.");
						return false;
					}else{
						//has input
						has_input = $('.treatment_select').length + $('.package_select').length + $('.nail_select').length;
						if(has_input != 0){
							empty = false;
							$('.treatment_select').each(function(){
								if($(this).val() == ""){
									empty = true;
								}
							});
							$('.package_select').each(function(){
								if($(this).val() == ""){
									empty = true;
								}
							});
							$('.nail_select').each(function(){
								if($(this).val() == ""){
									empty = true;
								}
							});
							if(empty){
								alert("Select treatment/product for all customers.");
								return false;
							}else{
								if(confirm("Complete the reservation?")){
									$('#group_form').submit();
									return true;
								}else{
									return false;
								}
							}
						}else{
							alert("Please select at lease one treatment/product.");
							return false;
						}
					}
				}
			});
			groupFirstRun = false;
		}
	}
	
	admin_time_exist = $('#admin_time').length;
	function setTicker(){
		$.ajax({
			type	:	"POST",
			url		:	"ajax_new.php",
			data	:	{command: "admin_time"},
			dataType:	"json",
			success	:	function(data){
				if(token == data.token){
					//same
				}else if(token != ""){
					$.ajax({
						type	:	"POST",
						url		:	"ajax_new.php",
						data	:	{command: "admin_time", type: "full"},
						dataType:	"json",
						success	:	function(data){
							console.log(data);
							$('#admin_time .dropzone').html(data.show);
							setBlockTimeButton();
							setTherapistCheckInButton();
							setHoverTimeBlock();
							setDeleteTimeButton();
							
							token = data.token;
							$('#admin_time .dropzone .update_time .time').html(data.update);
							
							//ticker
							theight = $(".table.time-table").height() - 8;
							$('.time_block_container .ticker').css({"height": theight, "left": data.ticker_xpos+"%"});
						}
					});
				}
				token = data.token;
				$('#admin_time .dropzone .update_time .time').html(data.update);
				
				//ticker
				theight = $(".table.time-table").height() - 8;
				$('.time_block_container .ticker').css({"height": theight, "left": data.ticker_xpos+"%"});
			}
		});
	}
	if(admin_time_exist){
		//firstset
		setBlockTimeButton();
		setTherapistCheckInButton();
		setHoverTimeBlock();
		setDeleteTimeButton();
		
		setTicker();
		//reload
		token = "";
		interval = setInterval(function(){
			setTicker();
		}, (10 * 60 * 1000)); //(นาที x วินาที x millisecond)
	}
	
	queue_human_exist = $('#queue_human').length;
	if(queue_human_exist){
		setDeleteWorktimeButton();
		
		//reload
		/* token = "";
		interval = setInterval(function(){
			$.ajax({
				type	:	"POST",
				url		:	"ajax_new.php",
				data	:	{command: "queue_human"},
				dataType:	"json",
				success	:	function(data){
					console.log(data);
					if(token == data.token){
						//same
					}else if(token != ""){
						$.ajax({
							type	:	"POST",
							url		:	"ajax_new.php",
							data	:	{command: "queue_human", type: "full"},
							dataType:	"json",
							success	:	function(data){
								console.log(data);
								$('#queue_human .dropzone').html(data.show);
								setDeleteWorktimeButton();
							}
						});
					}
					token = data.token;
					$('#queue_human .update_time .time').html(data.update);
				}
			});
		}, refresh_sec * 1000); */
	}
	
	orderlist_exist = $('#orderlist').length;
	if(orderlist_exist){
		//reload
		token = "";
		interval = setInterval(function(){
			$.ajax({
				type	:	"POST",
				url		:	"ajax_new.php",
				dataType:	"json",
				data	:	{command: "orderlist"},
				success	:	function(data){
					console.log(data);
					if(token == data.token){
						//same
					}else if(token != ""){
						//diff
						$.ajax({
							type	:	"POST",
							url		:	"ajax_new.php",
							data	:	{command: "orderlist", type: "full"},
							dataType:	"json",
							success	:	function(data){
								$('#cashier .left').html(data.show);
								setCheckedOrder();
							}
						});
					}
					token = data.token;
					$('#cashier .left .press_title .update_time .time').html(data.update);
					
				}
			});
		}, refresh_sec * 1000);
		setCheckedOrder();
	}
	
	new_cashier_form_exist = $('#new_cashier_form').length;
	if(new_cashier_form_exist){
		$('#new_cashier_form button[name=submit_button].submit_order').click(function(){
			// FOR CHECKING TREATMENT DISPLAY BUTTON : CHANG PROMOTION
			// SALE PAGE ALWAYS HAS 1 PERSON
			check_status = checkSaleButton(1);

			if(!check_status){
				alert("มีการเลือก treatment ไม่เข้าเงื่อนไข, กลับไปแก้ไขก่อนนะ");
				return false;
			}

			// COVID-19
			covid_exist = $('input[name=confirm_covid]').length;
			pass = checkCustomerInput();
			if(pass){
				if(covid_exist){
					if($('input[name=confirm_covid]').prop('checked') == true){
						// PASS
					}else{
						alertme("Please <b>tick the checkbox</b> to submit order.", "Confirm that the customer is healthy!");
						return false;
					}
				}
			}else{
				alertme("Please input <b>customer's info or wellnessme.co account</b> and <b>tick the checkbox</b> to submit order.", "Customer info required!");
				return false;
			}
			
			// NORMAL CHECK
			pass = requireCheck();
			
			if(pass){
				vars = $('#new_cashier_form').serialize();
				$.ajax({
					type		:	"POST",
					url			:	"ajax_new.php",
					data		:	vars,
					dataType	:	"json",
					error		:	function(data){
						console.log(data);
					},
					success		:	function(data){
						//$('#first').html(data.debug);
						// console.log(data);
						if(data.pass){
							// CHECK MEMBER
							loginExist = $('#loginStatus').length;
							if(loginExist){
								member_pass = $('#loginStatus').val();
							}else{
								member_pass = true;
							}
							if(member_pass){
								if(confirm("Complete the reservation?")){
									$('#new_cashier_form').submit();
									return true;
								}else{
									return false;
								}
							}else{
								alert('Member must login');
							}
						}else{
							if(data.command == "autowizard"){
								if(confirm(data.message)){
									$('.dropzone').fadeTo(200, 0.2).addClass('disable');
									$('.wizardzone').html('').fadeIn(200).addClass('loading black');
									wizardSuccess();
									return false;
								}else{
									return false;
								}
							}else{
								alert(data.message);
								return false;
							}
						}
					}
				});
			}else{
				return false;
			}
		});
		
		$('#new_cashier_form input[name=buymore], #new_cashier_form input[name=credit_note]').click(function(){
			if($(this).prop('checked')){
				$('#new_cashier_form button.wizard').hide();
				$(this).prop('checked', true);

				// CREDIT NOTE
				if($(this).attr('name') == 'credit_note'){
					$('.treatment_time_lable_box, .treatment_time_select_box').addClass('opacity2');
					$('.treatment_time_select_box select').prop('disabled', true);
				}
			}else{
				$('#new_cashier_form button.wizard').show();
				$(this).prop('checked', false);
				
				// CREDIT NOTE
				if($(this).attr('name') == 'credit_note'){
					$('.treatment_time_lable_box, .treatment_time_select_box').removeClass('opacity2');
					$('.treatment_time_select_box select').prop('disabled', false);
				}
			}
		});
	}
	
	orderlist_done_exist = $('#orderlist_done').length;
	if(orderlist_done_exist){
		$('input.order_checkbox').click(function(){
			$(this).parent().parent().parent().parent().parent().parent().parent().parent().find('input[name=print_id]').prop('checked', true);
		});
		$('input[name=print_id]').click(function(){
			$('#orderlist_done').find('.order_checkbox').prop('checked', false);
			$(this).parent().parent().parent().parent().parent().find('.order_checkbox').prop('checked', true);
		});
		$('#order_list_form .edit_order').click(function(){
			$('#order_list_form').attr("action", "?p=cashier_done");
			$('#order_list_form').attr("target", "");
		});
	}
	
	edit_order_form_exist = $('#edit_order_form').length;
	if(edit_order_form_exist){
		$('button[name=cancel-spa-detail]').click(function(){
			spa_detail_id = $(this).val();
			if(confirm("Cancel this treatment/package?")){
				loading();
				$.ajax({
					type	:	"POST",
					url		:	"ajax_new.php",
					data	:	{command : "delete_spa_detail_id", spa_detail_id: spa_detail_id},
					success	:	function(data){
						console.log(data);
						//alert(data);
						unload();
						location.reload();
					}
				});
			}else{
				return false;
			}
		});
		$('button[name=cancel-treatment]').click(function(){
			vars = $('#edit_order_form').serialize();
			treatment_detail_id = $(this).val();
			if(confirm("Cancel this treatment?")){
				loading();
				$.ajax({
					type	:	"POST",
					url		:	"ajax_new.php",
					data	:	{command : "delete_treatment", treatment_detail_id: treatment_detail_id, vars: vars},
					success	:	function(data){
						unload();
						//$('#member_menu').html(data);
						location.reload();
					}
				});
			}else{
				return false;
			}
		});
		$('button[name=change-therapist], button[name=change-therapist-cross]').click(function(){
			// VARS
			action = $(this).attr('action');
			button_type = $(this).attr('button_type');

			to_change = $(this).parent().parent().parent().find('.to_change');
			old = $(this).parent().parent().parent().find('.to_change .therapist_code').html();
			parent = $(this).parent().parent().parent().find('.therapist_div');
			
			console.log(button_type);

			// DISPLAY
			$('.change_type span').html(action).removeClass().addClass(action);

			// HIDE BUTTON
			// $('button[name=change-therapist], button[name=change-therapist-cross]').hide();

			$('button[name=submit_button]').val(action);
			select_box = $(this).parent().parent().parent();
			select_box.find('.acton_type').val(action);
			select_box.find('.new_therapist').show().prop('disabled', false);
			
			worktime_id = $(this).val();
			spa_id = $(this).attr('spa_id');
			
			if(button_type != "stretch"){
				to_change.hide();

				$('button.change-therapist-cross').remove();
				if(action == "cross"){
					$('button.change-therapist').remove();
				}
				
				input = "<div class='new_change row'><div class='col-sm-12'><input type='text' class='auto_employee form-control input-sm' name='work_array["+spa_id+"]["+worktime_id+"][new_therapist]' value=''><input type='hidden' name='work_array["+spa_id+"]["+worktime_id+"][action]' value='"+action+"'></div></div>";
				this_input = parent.append(input);
				this_input.find(".back").click(function(){
					$(this).parent().parent().parent().parent().find('.to_change').show();
					$(this).parent().parent().parent().find('.new_change').remove();
				});
				this_input.find(".auto_employee").autocomplete({
					source: path+"ajax_autocomplete.php?type=all",
					minLength: 1,
					autoFocus: true,
					close:	function(data){
						if(action == "cross"){
							new_var = $(this).val();
							$(".auto_employee").each(function(){
								current_code = $(this).val();
								if(current_code == old){
									//alert(current_code);
									$(this).val(new_var);
								}
							});
							$(".therapist_code").each(function() {
								current_code = $(this).html();
								if(current_code == old){
									//alert(current_code);
									$(this).html(new_var);
								}			        
							});
						}
					}
				});
			}
		});
	}
	
	//new live cal
	/* live calculate */
	setLiveCal();
	$('#new_payment_form .payment_type').change(function(){
		loading();
		this_obj = $(this);
		payment_detail_box = $(this).parent().parent().parent().parent().parent().find('.payment_detail_box');
		payment_type_id = $(this).val();
		index_id = $(this).attr('index_id');
		$.ajax({
			type : "POST",
			url : "ajax.php",
			dataType : "json",
			data : {command: "getPaymentSub", payment_type_id: payment_type_id, index_id: index_id},
			success : function(data){
				unload();
				parent_box = $('.payment_type').not(this_obj).parent().parent().parent().parent().parent();
				amount = parent_box.find('.payment_amount_input');
				disabled_detail_box = parent_box.find('.payment_detail_box');

				if(data.foc){
					$('.payment_type').not(this_obj).val('').prop('disabled', true);
					disabled_detail_box.html('');
					amount.val('').prop('disabled', true);
					$('input[name=is_foc]').val(true);
				}else{
					$('.payment_type').prop('disabled', false);
					amount.prop('disabled', false);
					$('input[name=is_foc]').val(false);
				}
				newRealtimeCalculation();

				// SHOW SUB PAYMENT
				payment_detail_box.html(data.show);

				// TRANSFER DEPOSIT
				$('select.transfer_deposit, select.city_vat').change(function(){
					$('.information_box').html("");
					// checkTransferDeposit();
					newRealtimeCalculation();
				});

				// EDC
				setEDC();
				setCreditCardNext();
			}
		});
	});

	//payment
	payment_exist = $('.payment_form').length; // Cashier Page & Product Page
	receipt_type = $('input[name=receipt_type]').val();

	page = $('input[name=page]').val();
	onsen_page = $('input[name=onsen_page]').val();
	
	if(payment_exist){
		setPaymentPage();
	}
	setNewPaymentDiscount();
});

function setNewPaymentDiscount(){
	// #new_payment_form (CASHIER PAGE)
	$('#new_payment_form .discount_percent_input').change(function(){
		if($('#new_payment_form .discount_percent_input').val() == ''){
			$('.discount_percent_input, .discount_amount_input, .main_content .sub_discount, .new_price_input').prop('disabled', false);
		}else{
			if($(this).is('.discount_percent_input')){
				$('.discount_percent_input').prop('disabled', false);
				$('.discount_amount_input, .main_content .sub_discount, .new_price_input').prop('disabled', true);
			}else{
				$('.discount_percent_input, .main_content .sub_discount, .new_price_input').prop('disabled', true);
				$('.discount_amount_input').prop('disabled', false);
			}
		}
		newRealtimeCalculation();
	});

	// NEW PRICE INPUT
	$('.new_price_input').change(function(){
		value = $(this).val();
		if(value > 0){
			$(this).parent().parent().parent().find('.discount_input').val('').prop('disabled', true);
			$('.discount_percent_input').val('').prop('disabled', true);
		}
	});
	// SUB % DISCOUNT
	$('.sub_discount').change(function(){
		value = $(this).val();
		if(value > 0){
			$(this).parent().parent().parent().find('.new_price_input').val('').prop('disabled', true);
			$('.discount_percent_input').val('').prop('disabled', true);
		}
	});

	// DISABLED TIER DISCOUNT
	$('.manual_discount_percent, .sub_discount, .new_price_input').bind('keyup', function(){
		check_have_value = (parseInt($('.manual_discount_percent').val()) || 0) + (parseInt($('.sub_discount').val()) || 0) + (parseInt($('.new_price_input').val()) || 0);
		this_value = $(this).val();
		this_name = $(this).attr('name');
		// console.log('check_have_value '+check_have_value);
		if(check_have_value > 0){
			turnTierDiscount(false);
		}else{
			if(globalThis.has_exclude_tier_discount_payment == true){
				// SKIP
			}else{
				turnTierDiscount(true);
			}
		}
		newRealtimeCalculation();
	});

	$('#new_payment_form .discount_amount_input').change(function(){
		if($('#new_payment_form .discount_amount_input').val() == ''){
			$('.discount_percent_input, .discount_amount_input, .main_content .sub_discount').prop('disabled', false);
		}else{
			if($(this).is('.discount_amount_input')){
				$('.discount_amount_input').prop('disabled', false);
				$('.discount_percent_input, .main_content .sub_discount').prop('disabled', true);
			}else{
				$('.discount_amount_input, .main_content .sub_discount').prop('disabled', true);
				$('.discount_percent_input').prop('disabled', false);
			}
		}
		newRealtimeCalculation();
	});
}
function checkTransferDeposit(){
	// CHECK TRANSFER DEPOSIT	
	var city_id;
	$('#payment_type_select .sub_group').each(function(){
		this_parent = sub_group = $(this);
		is_transfer_deposit = $(this).find('.transfer_deposit').length;

		is_city_vat = $(this).find('.city_vat').length;

		sub_id = this_parent.attr('id');

		if(is_transfer_deposit){
			city_id = $(this).find('.transfer_deposit').val();
			payment_type = "transfer_deposit";
			skip = false;
		}else if(is_city_vat){
			city_id = $(this).find('.city_vat').val();
			payment_type = "city_vat";
			skip = false;
		}else{
			skip = true;
		}
		if(!skip){
			payment_amount = $(this).find('.payment_amount_input').val();
			if(city_id > 0 && payment_amount > 0){
				$.ajax({
					type	:	"POST",
					url		:	"ajax.php",
					dataType:	"json",
					data	:	{
									command: "getdepositbalance", 
									city_id: city_id, 
									payment_amount: payment_amount, 
									sub_id: sub_id, 
									payment_type: payment_type
								},
					success	:	function(data){
						console.log(data);
						this_sub = $('#'+data.sub_id);
						this_pay_amount = this_sub.find('.payment_amount_input').val();

						// CAL
						if(!data.pass){
							// not enough
							this_sub.find('.information_box').html(data.show);

							// RESET VALUE
							this_sub.find('.payment_amount_input').val("");
						}else{
							this_sub.find('.information_box').html(data.show);
						}
					}
				});
			}
		}
	});
}
function setCheckedOrder(){
	$('.order_checkbox').click(function(){
		vars = $('#order_list_form').serializeArray();
		$.ajax({
			type	:	"POST",
			url		:	"ajax_new.php",
			data	:	{command: "session_order_checked", vars: vars},
			success	:	function(data){
			}
		});
	});
	$('#orderlist .button.reload').click(function(){
		location.reload();
	});
	
	$('#orderlist .button.delete').click(function(){
		//check variable
		vars = $('#order_list_form, #unpaid_form').serializeArray();
		// console.log(vars);
		$.ajax({
			type	:	"POST",
			url		:	"ajax_new.php?command=checkReceipt",
			data	:	vars,
			success	:	function(data){
				if(data){
					//set form attr
					if(confirm("Delete orders?")){
						delete_reason = prompt("Please enter your reason for delete order.");
						if($('#unpaid_form').length){
							// FOR UNPAID
							if(delete_reason){
								$('#unpaid_form input[name=button_command]').val("delete");
								$('#unpaid_form input[name=delete_reason]').val(delete_reason);
								$('#unpaid_form input[name=from_page]').val("unpaid");
								vars = $('#unpaid_form').serializeArray();
								$.ajax({
									type	:	"POST",
									url		:	"ajax.php",
									data	:	{command: "delete_order", vars: vars, page: "unpaid"},
									success	:	function(data){
										// console.log(data);
										location.reload();
									}
								});
							}else{
								return false;
							}
							return false;
						}else{
							if(delete_reason){
								$('#order_list_form input[name=button_command]').val("delete");
								$('#order_list_form input[name=delete_reason]').val(delete_reason);
								$('#order_list_form input[name=from_page]').val("cashier");
								$('#order_list_form').submit();
							}else{
								return false;
							}
						}
						return false;
					}else{
						return false;
					}
				}else{
					alert("Can not delete, some orders has already been paid.");
					return false;
				}
			}
		});
		return false;
	});
	$('#order_list_form .check_button').on('click', function(){
		total = $(this).parent().parent().find('input[type=checkbox]').length;
		checked = $(this).parent().parent().find('input[type=checkbox]:checked').length;

		if(checked < total){
			$(this).parent().parent().find('input[type=checkbox]').prop("checked", true);
		}else{
			$(this).parent().parent().find('input[type=checkbox]').prop("checked", false);
		}
	});
	
	$('#unpaid_form .check_button').click(function(){
		if($(this).attr('click') == "true"){
			$(this).parent().parent().parent().parent().parent().find('input[type=checkbox]').prop("checked", false);
			$(this).attr('click', false);
		}else{
			$(this).parent().parent().parent().parent().parent().find('input[type=checkbox]').prop("checked", true);
			$(this).attr('click', true);
		}
	});

	// MATERIAL DR. SPILLER
	$('.group_key_label').click(function(){
		$(this).parent().parent().find('.sub_material_list').fadeIn(200);
	});

	$('.print_work').click(function(){
		var is_no;
		is_no = true;
		$('input[type=checkbox].order_checkbox:checked').each(function(){
			material_select_box = $(this).parent().parent().parent().parent().parent().find('.material_select_box'); // TO REMOVE
			input_val = $(this).val();
			material_select_box.find('input[type=radio]:checked').each(function(){
				is_no_select = $(this).val();
				if(is_no_select == "no"){
					is_no = false;
				}
			});
		});

		// DOES NOT SELECT AND ORDER
		is_checked_order = $('input.order_checkbox:checked').length;
		is_radio_checked_order = $('input.order_radio:checked').length;
		if(is_checked_order + is_radio_checked_order == 0){
			alert('Please select at least 1 order');
			return false;
		}

		if(!is_no){
			alert("โปรดเลือก material ก่อนพิมพ์คูปองหมอ");
			return false;
		}else{
			return true;
		}
	});
	
	$('#order_list_form .print_order, #order_list_form .print_work').click(function(){
		$('#order_list_form').attr("action", "?p=print");
		$('#order_list_form').attr("target", "_blank");
	});
	$('#order_list_form .button.delete').click(function(){
		//set form attr
		$('#order_list_form').attr("action", "?p=cashier");
		$('#order_list_form').attr("target", "");
	});
	$('#order_list_form .print_receipt').click(function(){
		var is_no;
		is_no = true;
		$('input[type=checkbox].order_checkbox:checked').each(function(){
			material_select_box = $(this).parent().parent().parent().parent().parent().find('.material_select_box'); // TO REMOVE
			input_val = $(this).val();
			material_select_box.find('input[type=radio]:checked').each(function(){
				is_no_select = $(this).val();
				if(is_no_select == "no"){
					is_no = false;
				}
				// alert(input_val+" - "+is_no_select+" : "+is_no);
			});
		});

		// DOES NOT SELECT AND ORDER
		is_checked_order = $('input.order_checkbox:checked').length;
		is_radio_checked_order = $('input.order_radio:checked').length;
		if(is_checked_order + is_radio_checked_order == 0){
			alert('Please select at least 1 order');
			return false;
		}

		// REMOVE MATERIAL BOX
		if(!is_no){
			if(confirm("ยังไม่ได้เลือก material เดี๋ยวค่อยกลับมาเลือกตอนปริ้นท์คูปองหมอนะ?")){
				material_select_box.remove();
				is_no = true;
			}else{
				return false;
			}
		}
		// SUBMIT
		if(!is_no){
			alert("โปรดเลือก material ก่อนกดปุ่ม");
			return false;
		}else{
			//check variable
			vars = $('#order_list_form').serializeArray();
			$.ajax({
				type	:	"POST",
				url		:	"ajax_new.php?command=checkReceipt",
				data	:	vars,
				success	:	function(data){
					// console.log(data);
					if(data){
						//set form attr
						$('#order_list_form').attr("action", "?p=cashier");
						$('#order_list_form').attr("target", "");
						$('#order_list_form').append("<input type='hidden' name='submit_button' value='receipt'>");
						$('#order_list_form').submit();
						return true;
					}else{
						alert("Some orders has already been paid.");
						return false;
					}
				}
			});
			return false;
		}
	});
}
/**
 * สามารถใช้ Tier Discount ได้มั้ย?
 */
function canUseTierDiscount(){
	var sum_buy_id;
	var sum_card_input;
	var has_exclude_product = false;
	
	// console.log('CHECK PRODUCT THAT CANNOT USE TIER DISCOUNT');
	has_wallet_topup_item = $('input[product_type=wallet_topup').length;
	has_special_item = $('select[product_type=special').length;
	has_course_item = $('input[product_type=course').length;
	has_voucher_item = $('input[product_type=voucher').length;
	has_staff_product_item = $('input[product_type=staff_product').length;
	has_tier_percent_discount = $('.tier_percent_discount').length;
	has_manual_discount = (parseInt($('.manual_discount_percent').val()) || 0) + (parseInt($('.sub_discount').val()) || 0) + (parseInt($('.new_price_input').val()) || 0);
	has_voucher_box = $('.voucher_box').length;
	has_onsen_card_item = $('input[product_type=onsen_card').length;

	// HAS INELIGIBLE PAYMENT FOR TIER DISCOUNT
	window.has_exclude_tier_discount_payment = false;
	$('.payment_type').each(function(){
		payment_type_id = $(this).val();
		if(payment_type_id){
			if(payment_type_id == 8 || payment_type_id == 13 || payment_type_id == 10){
				window.has_exclude_tier_discount_payment = true;
			}
		}
	});
	has_ineligible_payment = window.has_exclude_tier_discount_payment;

	// HAS MEMBER INVENTORY
	sum_buy_id = 0;
	$('.inventory-select').each(function(){
		split_val = $(this).val().split(",");
		sum_buy_id += parseInt(split_val[0]);
	});
	has_member_inventory = sum_buy_id;

	// HAS CASHCARD
	sum_card_input = 0
	$('.card_input').each(function(){
		card_input = parseInt($(this).val());
		sum_card_input += card_input;
	});
	has_cashcard = sum_card_input;

	// HAS PRODUCT CATEGORY
	$('.product_group, .special_group').each(function(){
		use_tier_discount = $(this).attr('use_tier_discount');
		if(use_tier_discount == "0"){
			has_exclude_product = true;
		}
	});

	if((has_special_item || has_wallet_topup_item || has_course_item || has_voucher_item || has_staff_product_item || has_voucher_box || has_ineligible_payment || has_manual_discount || has_member_inventory || has_cashcard || has_exclude_product) && has_tier_percent_discount || has_onsen_card_item){
		turnTierDiscount(false);
		return false;
	}else{
		turnTierDiscount(true);
		return true;
	}
}
function newRealtimeCalculation(callback){ //for cashier page //code
	// QUICK RUN doQuickSummary() INSTEAD
	is_quick = $('input[name=quick_booking]').val();
	if(is_quick){
		doQuickSummary();
		return;
	}

	// CHECK PRODUCT THAT CANNOT USE TIER DISCOUNT
	if(canUseTierDiscount()){
		turnTierDiscount(true);
	}else{
		turnTierDiscount(false);
	}
	
	console.log("script_auto.js : newRealtimeCalculation");
	checkTransferDeposit();
	loading();
	vars = $('.payment_form').serialize();
	$.ajax({
		type 		:	"POST",
		url			:	"ajax_new.php?command=calculate",
		dataType	:	"json",
		data 		:	vars,
		error		:	function(e_data){
			$('#magicEye').html("error : newRealtimeCalculation");
			unload();
			// console.log(data);
		},
		success		:	function(e_data){
			$('#magicEye').html("");
			// console.log(e_data.round_payment);
			// console.log(e_data);
			unload();

			if(e_data.pass === false){
				alert(e_data.message);
				return false;
			}

			if(e_data.round_payment === false){
				// ไม่ปัดทศนิยม
				if(e_data.special_discount > 0){
					$('#payment_sum .payment_special_discount').show();
					$('#payment_sum .payment_special_discount .value').html("- "+e_data.special_discount);
				}else{
					$('#payment_sum .payment_special_discount').hide();
				}
				$('input[name=special_discount]').val(e_data.special_discount);
				
				$('#payment_sum .payment_paid .value').html(e_data.paid);
				$('#payment_sum .payment_mis .value').html(e_data.mis);
				$('#payment_sum .payment_balance .value').html(e_data.balance);

				$('#payment .sub_total .value').html(e_data.sub_total);
				$('#payment .discount .value').html(e_data.discount);
				$('#payment .mis .value').html(e_data.mis);
				$('#payment .before_total .value').html(e_data.before_total);
				if(e_data.page != 'product'){
					$('#payment .box.service, #payment .before_total').show();
				}else{
					$('#payment .box.service, #payment .before_total').hide();
				}
				
				$('#payment .service_charge .value').html(e_data.service_charge, 2);
				$('#payment .vat .value').html(e_data.government_tax, 2);
				
				//xxxxxxxxxxx
				//$('#payment .to_be_paid .value').html(e_data.to_be_paid, 2);
				
				$('#payment_sum .payment_total .value').html(e_data.total);
				$('#payment .grand_total .value').html(e_data.grand_total);
				//for FOC card
				$('#payment_sum input[name=payment_total]').val(e_data.grand_total);
					
				if(parseInt(e_data.balance) == 0 && parseInt(e_data.grand_total) > 0){
				// if(e_data.balance == 0){
					$('#payment_sum .padding').css("background-color","RGBA(0, 255, 0, 0.3)");
				}else{
					$('#payment_sum .padding').css("background-color","RGBA(255, 0, 0, 0.3)");
				}
				
				//FOC
				if(e_data.has_foc_card){
					$('#payment_sum2 .payment_total .value').html(e_data.foc.total);
					$('#payment_sum2 .payment_paid .value').html(e_data.foc.paid);
					$('#payment_sum2 .payment_balance .value').html(e_data.foc.balance);
					if(e_data.foc.paid > 0){
						$('#payment_sum2 .payment_special_discount .value').html(e_data.foc.special_discount);
						$('#payment_sum2 input[name=special_discount]').val(e_data.foc.special_discount);
						$('#payment_sum2 input[name=foc_amount]').val(e_data.foc.foc_amount);
					}else{
						console.log(e_data.foc.paid);
						$('#payment_sum2 .payment_special_discount .value').html("");
					}
					if(parseInt(e_data.foc.balance) == 0 && parseInt(e_data.foc.total) > 0){
						$('#payment_sum2 .padding').css("background-color","RGBA(0, 255, 0, 0.3)");
					}else{
						$('#payment_sum2 .padding').css("background-color","RGBA(255, 0, 0, 0.3)");
					}
				}
			}else{
				// ปัดทศนิยม
				if(e_data.special_discount > 0){
					$('#payment_sum .payment_special_discount').show();
					$('#payment_sum .payment_special_discount .value').html("- "+e_data.special_discount);
				}else{
					$('#payment_sum .payment_special_discount').hide();
				}
				$('input[name=special_discount]').val(e_data.special_discount);
				
				$('#payment_sum .payment_paid .value').html(e_data.paid);
				// $('#payment_sum .payment_mis .value').html(e_data.mis);
				$('#payment_sum .payment_rounding .value').html(e_data.mis);
				if(e_data.mis){
					$('.payment_rounding').removeClass('hide');
				}else{
					$('.payment_rounding').addClass('hide');
				}
				$('#payment_sum .payment_balance .value').html(e_data.balance);

				$('#payment .sub_total .value').html(e_data.sub_total);
				$('#payment .discount .value').html(e_data.discount);
				$('#payment .mis .value').html(e_data.mis);
				$('#payment .before_total .value').html(e_data.before_total);
				if(e_data.page != 'product'){
					$('#payment .box.service, #payment .before_total').show();
				}else{
					$('#payment .box.service, #payment .before_total').hide();
				}
				
				$('#payment .service_charge .value').html(e_data.service_charge, 2);
				$('#payment .vat .value').html(e_data.government_tax, 2);
				
				//xxxxxxxxxxx
				//$('#payment .to_be_paid .value').html(e_data.to_be_paid, 2);
				
				$('#payment_sum .payment_total .value').html(e_data.total);
				$('#payment .grand_total .value').html(e_data.grand_total);
				//for FOC card
				$('#payment_sum input[name=payment_total]').val(e_data.grand_total);
				
				if(e_data.balance <= 0 && e_data.balance > -1){
					// BALANCE MINUS DECIMAL
					$('#payment_sum .padding').css("background-color","RGBA(0, 255, 0, 0.3)");
				}else if(e_data.balance == 0){
					// BALANCE EXACT ZERO
					$('#payment_sum .padding').css("background-color","RGBA(0, 255, 0, 0.3)");
				}else{
					$('#payment_sum .padding').css("background-color","RGBA(255, 0, 0, 0.3)");
				}
				
				//FOC
				if(e_data.has_foc_card){
					$('#payment_sum2 .payment_total .value').html(e_data.foc.total);
					$('#payment_sum2 .payment_paid .value').html(e_data.foc.paid);
					$('#payment_sum2 .payment_balance .value').html(e_data.foc.balance);
					if(e_data.foc.paid > 0){
						$('#payment_sum2 .payment_special_discount .value').html(e_data.foc.special_discount);
						$('#payment_sum2 input[name=special_discount]').val(e_data.foc.special_discount);
						$('#payment_sum2 input[name=foc_amount]').val(e_data.foc.foc_amount);
					}else{
						console.log(e_data.foc.paid);
						$('#payment_sum2 .payment_special_discount .value').html("");
					}
					if(parseInt(e_data.foc.balance) == 0 && parseInt(e_data.foc.total) > 0){
						$('#payment_sum2 .padding').css("background-color","RGBA(0, 255, 0, 0.3)");
					}else{
						$('#payment_sum2 .padding').css("background-color","RGBA(255, 0, 0, 0.3)");
					}
				}
			}

			// SURPLUS INCOME
			$('#surplus_payment_input').val(e_data.surplus_income);
			if(e_data.surplus_income > 0){
				$('#payment_sum .padding, #payment_sum2 .padding').css("background-color","RGBA(255, 200, 50, 0.7)");
			}

			// CONVERTED BALANCE
			convertedBalance(e_data.balance);

			// CALLBACK
			if(callback){
				callback();
			}
		}
	});
}
function convertedBalance(amount){
	// CONVERTED BALANCE
	if(amount !== undefined) {
		/* converted_balance_exist = $('#converted-balance').length;
		if(converted_balance_exist){
			$.ajax({
				type 		:	"POST",
				url			:	"ajax.php",
				dataType	:	"json",
				data 		:	{command: 'convert_balance', amount: amount},
				success		:	function(data){
					$('#converted-balance').html(data.show);
				}
			});
		} */
	}
}
function setButtonTreatment(){
	var branch_id;
	$('#new_cashier_form .button.treatment').off('click');
	$('#new_cashier_form .button.treatment').click(function(){
		current_product = $('.item_group').length;
		current_product++;
		loading();

		// REMOVE OTHER BUTTON
		$('button.nest, button.token').remove();

		// DISABLED
		button = $(this);
		button.prop('disabled', true);

		loading();

		dropzone = $(this).parent().parent().find('.dropzone');
		if(!dropzone.length){
			dropzone = $('.dropzone');
		}

		person = $(this).attr('person');
		data_source = $(this).attr('data-source');

		autocomplete_source = path+"ajax_autocomplete.php?type=treatment";

		// GET branch_id IF AROUND
		branch_id = $('input[name=branch_id]').val() ? $('input[name=branch_id]').val() : $('select[name=branch_id]').val();
		if(branch_id > 0){
			autocomplete_source = autocomplete_source+'&branch_id='+branch_id;
		}

		$.ajax({
			type	:	"POST",
			url		:	path+"ajax.php",
			data	:	{command: "getTreatment", current_product: current_product, branch_id: branch_id, person: person, data_source: data_source},
			success	:	function(data){
				if(!data){
					alert('Please select branch');
				}
				unload();
				button.prop('disabled', false);
				clearWizard();
				dropzone.append(data);
				setNumberOnly();
				dropzone.find('.auto_employee').autocomplete({
					source: path+"ajax_autocomplete.php?type=all",
					minLength: 1,
					autoFocus: true,
					change:	function(data){
					}
				});

				// FOR OLD DROPDOWN
				treatment_parent = $('select.treatment_select'+current_product).parent().parent().parent().parent();
				treatment_parent.find('select.treatment_select').change(function(){
					therapist_amount = $(this).find('option:selected').attr('therapist_amount');
					index_id = parseInt($(this).attr('index_id'));
					person_no = parseInt($(this).attr('person_no'));
					therapis_box = $(this).parent().parent().parent().parent().find('.therapist');
					is_onsen = $(this).attr('is_onsen');
					therapis_box.html('');

					select_type = $(this).attr('select_type');
					if(select_type == "pax"){
						input_name = 'order['+person_no+'][product]';
					}else{
						input_name = 'product';
					}
					
					for(var i = 1; i <= therapist_amount; i++){
						therapis_box.append("<div class='box'><input type='text' name='"+input_name+"["+index_id+"][therapist]["+i+"]' class='form-control auto_employee input-sm press_title line bold pink' placeholder='therapist "+i+"'></div>");
					}
					
					therapis_box.find('.auto_employee').autocomplete({
						source: path+"ajax_autocomplete.php?type=all",
						minLength: 1,
						autoFocus: true,
						select:	function(event, ui){
							$(this).parent().parent().parent().parent().parent().find('.reserve_therapist .reserve_checkbox').val(ui.item.value);
						}
					});
					if(therapist_amount == 0){
						$(this).parent().parent().parent().find('.auto_employee').prop('disabled', true).hide();
						$(this).parent().parent().parent().parent().find('.reserve_checkbox').prop('checked', false).prop('disabled', true);
					}else{
						$(this).parent().parent().parent().find('.auto_employee').prop('disabled', false).show();
						$(this).parent().parent().parent().parent().find('.reserve_checkbox').prop('disabled', false);
					}
				});

				// NEW AUTOCOMPLETE
				auto_treatment_parent = $('.auto_treatment.treatment_select'+current_product).parent().parent().parent().parent();
				auto_treatment_parent.find('.auto_treatment').autocomplete({
					source: autocomplete_source,
					minLength: 0,
					autoFocus: true,
					create: function(event, ui){
					},
					close:	function(){
					},
					change: function(){
					},
					select: function(event, ui) {
						therapist_amount = parseInt(ui.item.therapist_amount);
						index_id = parseInt($(this).attr('index_id'));
						person_no = parseInt($(this).attr('person_no'));
						therapis_box = $(this).parent().parent().parent().parent().find('.therapist');
						is_onsen = ui.item.is_onsen
						$(this).attr('is_onsen', is_onsen);
						therapis_box.html('');

						// CHECK ONSEN
						if(is_onsen){
							person_exist = $('.person').length; // QUICKBOOK
							if(person_exist > 0){
								// LOOP BY CUSTOMER
								$('.person').each(function(){
									onsen_count = $(this).find('.treatment_select[is_onsen=true]').length;
									if(onsen_count > 1){
										alertme("", "<span class='pink'>Only one Onsen</span> can be selected per order.");
										$(this).parent().parent().remove();
										return false;
									}
								});
							}else{
								onsen_count = $('.treatment_select[is_onsen=true]').length;
								if(onsen_count > 1){
									alertme("", "<span class='pink'>Only one Onsen</span> can be selected per order.");
									$(this).val("");
									return false;
								}
							}
							
						}

						// DISTINATION SELECT
						$(this).parent().find('.destination-select').val(ui.item.product_id);

						select_type = $(this).attr('select_type');
						if(select_type == "pax"){
							input_name = 'order['+person_no+'][product]';
						}else{
							input_name = 'product';
						}
						
						for(var i = 1; i <= therapist_amount; i++){
							therapis_box.append("<div class='box'><input type='text' name='"+input_name+"["+index_id+"][therapist]["+i+"]' class='form-control auto_employee input-sm press_title line bold pink' data-therapist_amount="+therapist_amount+" placeholder='therapist "+i+"'></div>");
						}
						
						therapis_box.find('.auto_employee').autocomplete({
							source: path+"ajax_autocomplete.php?type=all",
							minLength: 1,
							autoFocus: true,
							select:	function(event, ui){
								therapis_box.parent().parent().find('.reserve_therapist .reserve_checkbox').val(ui.item.value);
							}
						});

						// CREATE RESERVE BOX
						reserve_therapist_box = therapis_box.parent().parent().parent().find('.reserve_therapist');
						reserve_therapist_box.html('');
						for(var i = 1; i <= therapist_amount; i++){
							reserve_input_name = 'order['+person_no+'][product]';
							reserve_therapist_box.append('<div class="box"><label><input type="checkbox" name="'+reserve_input_name+'['+index_id+'][reserve]['+i+']" class="reserve_checkbox form_control sm-input"><span class="press_title size-1">request</span></label></div>');
						}
						
						// DISABLED
						if(therapist_amount == 0){
							therapis_box.find('.auto_employee').prop('disabled', true).hide();
							therapis_box.parent().find('.reserve_checkbox').prop('checked', false).prop('disabled', true);
						}else{
							therapis_box.find('.auto_employee').prop('disabled', false).show();
							therapis_box.parent().find('.reserve_checkbox').prop('disabled', false);
						}
					}
				});

				auto_treatment_parent.find('.button.remove').click(function(){
					to_delete = $(this).parent().parent();
					if(confirm(confirm_delete)){
						to_delete.remove();
						doQuickSummary();
					}
				});
				
				auto_treatment_parent.find('.live_cal').change(function(){
					doQuickSummary();
				});
				
				treatment_parent.find('.button.remove').click(function(){
					to_delete = $(this).parent().parent();
					if(confirm(confirm_delete)){
						to_delete.remove();
						doQuickSummary();
					}
				});
				
				treatment_parent.find('.live_cal').change(function(){
					doQuickSummary();
				});
				current_product++;
			}	
		});
	});
}
function setButtonPackage(){
	var branch_id;
	$('#new_cashier_form .button.package').off('click');
	$('#new_cashier_form .button.package').click(function(){
		current_product = $('.item_group').length;
		current_product++;

		loading();

		// REMOVE OTHER BUTTON
		$('button.nest, button.token').remove();

		// DISABLED
		button = $(this);
		button.prop('disabled', true);

		dropzone = $(this).parent().parent().find('.dropzone');
		if(!dropzone.length){
			dropzone = $('.dropzone');
		}

		person = $(this).attr('person');
		data_source = $(this).attr('data-source');

		// GET branch_id IF AROUND
		branch_id = $('input[name=branch_id]').val() ? $('input[name=branch_id]').val() : $('select[name=branch_id]').val();
		
		$.ajax({
			type	:	"POST",
			url		:	path+"ajax.php",
			data	:	{command: "getPackage", current_product: current_product, branch_id: branch_id, person: person, data_source: data_source},
			success	:	function(data){
				if(!data){
					alert('Please select branch');
				}
				unload();
				button.prop('disabled', false);
				clearWizard();
				dropzone.append(data);
				setNumberOnly();
				dropzone.find('.auto_employee').autocomplete({
					source: path+"ajax_autocomplete.php?type=all",
					minLength: 1,
					autoFocus: true
				});
				$('.package_select'+current_product).change(function(){
					loading();
					obj = $(this);
					package_detail = obj.parent().parent().parent().parent().parent().find('.package_detail');
					product_id = $(this).val();
					index_id = $(this).attr('index');
					person = $(this).attr('person');
					$.ajax({
						type	:	"POST",
						url		:	path+"ajax.php",
						data	:	{command: "getPackageDetail", product_id: product_id, index_id: index_id, person: person},
						success	:	function(data){
							unload();
							package_detail.html(data).fadeIn(100, function(){
								$('.sortable-treatment').sortable({
									placeholder: "sortable-treatment-highlight",
									handle: ".drag_sort",
									opacity: 0.5,
									stop: function () {
										console.log($(this));
									}
								});
							});
							package_detail.find('.auto_employee').autocomplete({
								source: path+"ajax_autocomplete.php?type=all",
								minLength: 1,
								autoFocus: true,
								close:	function(){
									sub_index = $(this).attr("sub_index");
									therapist_amount = parseInt($(this).attr('therapist'));
									if(therapist_amount > 1){
										child_index = $(this).parent().parent().index();
									}else{
										child_index = $(this).parent().parent().parent().parent().index();
									}
									if(child_index == 0){
										val = $(this).val();
										if(sub_index == 1){
											if(therapist_amount > 1){
												$(this).parent().parent().parent().parent().parent().find('.auto_employee').filter('[index_type=odd]').val(val);
											}else{
												$(this).parent().parent().parent().parent().parent().find('.auto_employee').not(':eq(0)').val(val);
											}
										}else{
										}
									}
								},
								select:	function(event, ui){
									$(this).parent().parent().parent().parent().parent().find('.reserve_therapist .reserve_checkbox').val(ui.item.value);
								}
							});
						}
					});
				});
				parent = $('.package_select'+current_product).parent().parent().parent().parent();
				parent.find('.button.remove').click(function(){
					to_delete = $(this).parent().parent().parent();
					if(confirm(confirm_delete)){
						to_delete.remove();
						doQuickSummary();
					}
				});
				parent.find('.live_cal').change(function(){
					doQuickSummary();
				});
				current_product++;
			}
		});
	});
}

// AUTO BUTTON
function setSaleButton(){
	var branch_id;
	var form_vars;
	current_product = 1;

	$('.sale-button').off('click');
	$('.sale-button').click(function(){
		button_type = $(this).attr('button_type');

		customer_index = $(this).attr('index');
		menu_type = $(this).val();

		is_strict = $(this).attr('data-strict');
		is_require_voucher = $(this).attr('data-require-voucher');
		item_type = $(this).attr('data-item-type');

		// REMOVE BUTTON WITH STRICT VALUE
		if(is_strict){
			$('.sale-menu-button button:not(.'+menu_type+'):not(".wizard")').remove();
			$('#new_cashier_form').append('<input type="hidden" name="order_type" value="'+menu_type+'">');
		}else{
			$('.sale-menu-button button[data-strict=1]:not(".wizard")').remove();
		}

		if(is_require_voucher){
			$('#sale-page-encrypt-voucher-box').removeClass('hide');
			$('#voucher_encrypt_code').addClass('require').prop('required', true);
		}

		// NEST
		if(menu_type == 'nest'){
			$('#OnsenScanBox').html('<div class="press_title size-2 text-right"><i class="fas fa-info-circle dblue"></i> ไม่ต้องใช้ Wristband ณ จุดนี้</div><input type="hidden" name="skip-check-wristband" value="true">');
		}

		// ORDER TYPE, BUTTON TYPE
		autocomplete_source = path+"ajax_autocomplete.php?type=treatment";
		if(menu_type){
			autocomplete_source = autocomplete_source+"&menu_type="+menu_type;
		}

		dropzone = $(this).parent().parent().find('.dropzone');
		if(!dropzone.length){
			dropzone = $('.dropzone');
		}

		// FORM
		if($('#quick-booking-form').length > 0){
			form_vars = $('#quick-booking-form').serialize();
		}else if($('#new_cashier_form').length > 0){
			form_vars = $('#new_cashier_form').serialize();
		}

		// OVERIDE customer_index
		person = $(this).attr('person');

		// GET branch_id IF AROUND
		branch_id = $('input[name=branch_id]').val() ? $('input[name=branch_id]').val() : $('select[name=branch_id]').val();
		if(branch_id > 0){
			autocomplete_source = autocomplete_source+'&branch_id='+branch_id;
		}

		thisButton = $(this);
		$.ajax({
			type	:	"POST",
			url		:	path+"ajax.php",
			data	:	{command: "getMenu", current_product: current_product, type: button_type, customer_index: customer_index, menu_type: menu_type, person: person, item_type: item_type, form_vars: form_vars},
			dataType:	"json",
			success	:	function(data){
				unload();
				clearWizard();

				// CLEAR ANNOUNCE
				$('.announce').fadeOut(100).remove();

				// DISPLAY
				dropzone.append(data.show);

				if(data.pass){
					setNumberOnly();

					// TREATMENT
					dropzone.find('.auto_employee').autocomplete({
						source: path+"ajax_autocomplete.php?type=all",
						minLength: 1,
						autoFocus: true,
						change:	function(data){
						}
					});

					// AUTO TREATMENT
					auto_treatment_parent = $('.auto_treatment.treatment_select'+current_product).parent().parent().parent().parent();
					auto_treatment_parent.find('.auto_treatment').autocomplete({
						source: autocomplete_source,
						minLength: 0,
						autoFocus: true,
						select: function(event, ui) {
							therapist_amount = parseInt(ui.item.therapist_amount);
							index_id = parseInt($(this).attr('index_id'));
							person_no = parseInt($(this).attr('person_no'));
							therapis_box = $(this).parent().parent().parent().parent().find('.therapist');
							therapis_box.html('');

							// DISTINATION SELECT
							$(this).parent().find('.destination-select').val(ui.item.product_id);

							select_type = $(this).attr('select_type');
							if(select_type == "pax"){
								input_name = 'order['+person_no+'][product]';
							}else{
								input_name = 'product';
							}
							
							for(var i = 1; i <= therapist_amount; i++){
								therapis_box.append("<div class='box'><input type='text' name='"+input_name+"["+index_id+"][therapist]["+i+"]' class='form-control auto_employee input-sm' placeholder='therapist'></div>");
							}
							
							therapis_box.find('.auto_employee').autocomplete({
								source: path+"ajax_autocomplete.php?type=all",
								minLength: 1,
								autoFocus: true,
								select:	function(event, ui){
									$(this).parent().parent().parent().parent().parent().find('.reserve_therapist .reserve_checkbox').val(ui.item.value);
								}
							});
							if(therapist_amount == 0){
								$(this).parent().parent().parent().find('.auto_employee').prop('disabled', true).hide();
								$(this).parent().parent().parent().parent().find('.reserve_checkbox').prop('checked', false).prop('disabled', true);
							}else{
								$(this).parent().parent().parent().find('.auto_employee').prop('disabled', false).show();
								$(this).parent().parent().parent().parent().find('.reserve_checkbox').prop('disabled', false);
							}
						}
					});

					// TREATMENT
					treatment_parent = $('.treatment_select'+current_product).parent().parent().parent().parent();
					treatment_parent.find('.treatment_select').change(function(){										
						therapist_amount = $(this).find('option:selected').attr('therapist_amount');
						index_id = parseInt($(this).attr('index_id'));
						person_no = parseInt($(this).attr('person_no'));
						therapis_box = $(this).parent().parent().parent().parent().find('.therapist');
						therapis_box.html('');

						select_type = $(this).attr('select_type');
						if(select_type == "pax"){
							input_name = 'order['+person_no+'][product]';
						}else{
							input_name = 'product';
						}
						
						for(var i = 1; i <= therapist_amount; i++){
							therapis_box.append("<div class='box'><input type='text' name='"+input_name+"["+index_id+"][therapist]["+i+"]' class='form-control auto_employee input-sm' placeholder='therapist'></div>");
						}
						
						therapis_box.find('.auto_employee').autocomplete({
							source: path+"ajax_autocomplete.php?type=all",
							minLength: 1,
							autoFocus: true,
							select:	function(event, ui){
								$(this).parent().parent().parent().parent().parent().find('.reserve_therapist .reserve_checkbox').val(ui.item.value);
							}
						});
						if(therapist_amount == 0){
							$(this).parent().parent().parent().find('.auto_employee').prop('disabled', true).hide();
							$(this).parent().parent().parent().parent().find('.reserve_checkbox').prop('checked', false).prop('disabled', true);
						}else{
							$(this).parent().parent().parent().find('.auto_employee').prop('disabled', false).show();
							$(this).parent().parent().parent().parent().find('.reserve_checkbox').prop('disabled', false);
						}
					});

					// PACKAGE
					{
						package_parent = $('.package_select'+current_product).parent().parent().parent().parent();
						$('.package_select'+current_product).change(function(){
							loading();
							obj = $(this);
							package_detail = obj.parent().parent().parent().parent().parent().find('.package_detail');
							product_id = $(this).val();
							index_id = $(this).attr('index');
							person = $(this).attr('person');
							$.ajax({
								type	:	"POST",
								url		:	path+"ajax.php",
								data	:	{command: "getPackageDetail", product_id: product_id, index_id: index_id, person: person},
								success	:	function(data){
									unload();
									package_detail.html(data).fadeIn(100, function(){
										$('.sortable-treatment').sortable({
											placeholder: "sortable-treatment-highlight",
											handle: ".drag_sort",
											opacity: 0.5,
											stop: function () {
												console.log($(this));
											}
										});
									});
									package_detail.find('.auto_employee').autocomplete({
										source: path+"ajax_autocomplete.php?type=all",
										minLength: 1,
										autoFocus: true,
										close:	function(){
											sub_index = $(this).attr("sub_index");
											therapist_amount = parseInt($(this).attr('therapist'));
											if(therapist_amount > 1){
												child_index = $(this).parent().parent().index();
											}else{
												child_index = $(this).parent().parent().parent().parent().index();
											}
											if(child_index == 0){
												val = $(this).val();
												if(sub_index == 1){
													if(therapist_amount > 1){
														$(this).parent().parent().parent().parent().parent().find('.auto_employee').filter('[index_type=odd]').val(val);
													}else{
														$(this).parent().parent().parent().parent().parent().find('.auto_employee').not(':eq(0)').val(val);
													}
												}else{
												}
											}
										},
										select:	function(event, ui){
											$(this).parent().parent().parent().parent().parent().find('.reserve_therapist .reserve_checkbox').val(ui.item.value);
										}
									});
								}
							});
						});
					}

					// REMOVE
					auto_treatment_parent.find('.button.remove').click(function(){
						alert('a');
						to_delete = $(this).parent().parent();
						if(confirm(confirm_delete)){
							to_delete.remove();
							doQuickSummary();
						}
					});
					treatment_parent.find('.button.remove').click(function(){
						to_delete = $(this).parent().parent();
						if(confirm(confirm_delete)){
							to_delete.remove();
							doQuickSummary();
						}
					});
					package_parent.find('.button.remove').click(function(){
						to_delete = $(this).parent().parent();
						if(confirm(confirm_delete)){
							to_delete.remove();
							doQuickSummary();
						}
					});
					
					treatment_parent.find('.live_cal').change(function(){
						doQuickSummary();
					});
					package_parent.find('.live_cal').change(function(){
						doQuickSummary();
					});
					current_product++;
				}
			}
		});
	});
}

function checkSaleButton(person){
	var result;
	var sale_button_exist;

	sale_button_exist = $('.button.sale-button').length;
	if(sale_button_exist == 0){
		// SKIP CHECKING IF NO SALE BUTTON
		return true;
	}

	// FORM
	if($('#quick-booking-form').length > 0){
		form_vars = $('#quick-booking-form').serialize();
	}else if($('#new_cashier_form').length > 0){
		form_vars = $('#new_cashier_form').serialize();
	}

	result = true;
	$('.button.sale-button').each(function(){
		item_type = $(this).attr("button_type");

		// CHECK WITH AJAX
		$.ajax({
			type	:	"POST",
			url		:	path+"ajax.php",
			data	:	{command: "checkMenu", item_type: item_type, person: person, form_vars: form_vars},
			dataType:	"json",
			async	:	false, 
			success	:	function(data){
				if(!data.pass){
					result = data.pass;
				}
			}
		});
	});

	// REMOVE ANNOUNCE
	if(result){
		$('.announce.danger').remove();
	}
	return result;
}

//block time popup
function setTherapistCheckInButton(){
	$('.check-in').click(function(){
		loading();
		employee_id = $(this).attr('employee_id');
		$.ajax({
			type	:	"POST",
			url		:	"ajax.php",
			data	:	{command: "getTherapistCheckIn", employee_id: employee_id},
			success	:	function(data){
				unload();
				$('.popup').html(data).fadeIn(0, function(){
					$('#therapistcheckin input[name=checkin-time]').timepicker({
						"showCloseButton"	:	true
					});
					
					$('.popup .submit').click(function(){
						loading();
						vars = $('#therapistcheckin_form').serialize();
						console.log(vars);
						$.ajax({
							type	:	"POST",
							url		:	"ajax.php",
							data	:	{command: "doTherapistCheckIn", vars: vars, employee_id: employee_id},
							dataType:	"json",
							async	:	false, 
							success	:	function(data){
								unload();
								$('.popup').html(data.show);
								getAdminTimePage();
								sub_height = $('.popup .announce').height() + $('.popup pre').height();
								height = sub_height + 25;
								//height = 700;
								$('.popup').css("height", height);

								window.setTimeout(function(){
									$('.popup').hide();
									refreshTime();
								}, 500);
							}
						});
						return false;
					});
					
					$('.popup .close_popup').click(function(){
						$('.popup').fadeOut(100, function(){
							$(this).height(0);
						});
					});

					sub_height = $('#therapistcheckin').height();
					height = sub_height + 20;
					$('.popup').height(height);
				});
			}
		});
	});
}
function setBlockTimeButton(){
	// SEND TO POOL
	$('.block_time_pool').click(function(){
		loading();
		employee_id = $(this).attr('employee_id');
		$.ajax({
			type	:	"POST",
			url		:	"ajax.php",
			dataType:	"json",
			data	:	{command: "getBlockTimePool", employee_id: employee_id},
			success	:	function(data){
				unload();
				console.log(data);
				$('.popup').html(data.show).show();
				height = $('.popup #block_time').height() + 20;
				$('.popup').height(height);

				// SAVE
				$('.popup .add').click(function(){
					start = Date.parse($('#block_time_form input[name=start_time]').val());
					end = Date.parse($('#block_time_form input[name=end_time]').val());
					//alert(start+" | "+end);
					if(start >= end){
						alert("Please input the correct time.");
					}else if($('select[name=block_time_type]').val() == ""){
						alert("Please select the block type.");
					}else{
						loading();
						getdata = $('#block_time_form').serialize();
						$.ajax({
							type	:	"POST",
							url		:	"ajax.php",
							dataType:	"json",
							data	:	getdata,
							error	:	function(data){
								console.log(data);	
							},
							success		:	function(data){
								unload();
								$('.popup').html(data.show, function(){
									sub_height = $('.popup .announce').height();
									height = sub_height;
									$('.popup').height(height);

									refreshTime();
								});
								
								window.setTimeout(function(){
									$('.popup').fadeOut(100, function(){
										if(data.pass == true){
											refreshTime();
										}else{
											$('.popup').fadeOut(100);
										}
									});
								}, 100);									
							}
						});
					}
					return false;
				});
				

				$('.popup .close_popup').click(function(){
					$('.popup').fadeOut(100);
				});
			}
		});
	});

	$('.block_time').click(function(){
		loading();
		employee_id = $(this).attr('employee_id');
		$.ajax({
			type	:	"POST",
			url		:	"ajax.php",
			data	:	{command: "getBlockTime", employee_id: employee_id},
			success	:	function(data){
				unload();
				$('.popup').html(data).fadeIn(0, function(){
					//set unblock
					$('.popup .unblock_time').click(function(){
						time_id = $(this).attr('time_id');
						if(confirm("remove this?")){
							$.ajax({
								type		:	"POST",
								data		:	{command: "unblock_time", time_id: time_id},
								url			:	"ajax.php",
								beforeSend	:	function(){},
								error		:	function(){},
								success		:	function(data){
									$('.popup').html(data);
									sub_height = $('.popup .announce').height();
									height = sub_height + 25;
									$('.popup').animate({"height": height}, 100, function(){
									});
									window.setTimeout(function(){
										$('.popup').fadeOut(100, function(){
											refreshTime();
										});
									}, 100);
								}
							});
						}else{
							
						}
					});

					height = $('.popup #block_time').height() + 20;
					$('.popup').height(height);
					
					$('#block_time_form input[name=start_time], #block_time_form input[name=end_time]').timepicker({
						"showCloseButton"	:	true
					});
					$('.popup .add').click(function(){
						start = Date.parse($('#block_time_form input[name=start_time]').val());
						end = Date.parse($('#block_time_form input[name=end_time]').val());
						//alert(start+" | "+end);
						if(start >= end){
							alert("Please input the correct time.");
						}else if($('select[name=block_time_type]').val() == ""){
							alert("Please select the block type.");
						}else{
							loading();
							getdata = $('#block_time_form').serialize();
							console.log(getdata);
							$.ajax({
								type	:	"POST",
								url		:	"ajax.php",
								dataType:	"json",
								data	:	getdata,
								error	:	function(data){
									console.log(data);	
								},
								success		:	function(data){
									unload();
									$('.popup').html(data.show, function(){
										sub_height = $('.popup .announce').height();
										height = sub_height;
										$('.popup').height(height);

										refreshTime();
									});
									
									window.setTimeout(function(){
										$('.popup').fadeOut(100, function(){
											if(data.pass == true){
												refreshTime();
											}else{
												$('.popup').fadeOut(100);
											}
										});
									}, 100);									
								}
							});
						}
						return false;
					});
					$('.popup .close_popup').click(function(){
						$('.popup').fadeOut(100);
					});
				});
			}
		});
	});
}
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function setGroupButtonTreatment(){
	current_product = 1;
	$('#group_form .button.treatment').click(function(){
		loading();
		customer = $(this).attr('index');
		$.ajax({
			type	:	"POST",
			url		:	path+"ajax_group.php",
			dataType:	"json",
			data	:	{command: "getGroupTreatment", customer: customer},
			success	:	function(data){
				unload();
				clearWizard();
				$('.customer'+customer+' .customer_drop_zone').append(data.show);
				setNumberOnly();
				$('.customer'+customer+' .customer_drop_zone .auto_employee').autocomplete({
					source: path+"ajax_autocomplete.php?type=all",
					minLength: 1,
					autoFocus: true
				});
				index_id = customer;
				
				parent = $('.customer'+customer+' .treatment_group'+index_id);
				
				parent.find('.treatment_select').change(function(){	
					index_id = $(this).attr('index_id');
					customer = $(this).attr('customer');
					
					therapist_amount = $(this).find('option:selected').attr('therapist_amount');
										
					therapis_box = $(this).parent().parent().parent().parent().find('.therapist');
					therapis_box.html('');
					
					for(var i = 1; i <= therapist_amount; i++){
						therapis_box.append("<div class='box'><input type='text' name='group_product["+customer+"]["+index_id+"][therapist]["+i+"]' class='form-control auto_employee input-sm' placeholder='therapist'></div>");
					}
					
					therapis_box.find('.auto_employee').autocomplete({
						source: path+"ajax_autocomplete.php?type=all",
						minLength: 1,
						autoFocus: true,
						select:	function(event, ui){
							$(this).parent().parent().parent().parent().parent().find('.reserve_therapist .reserve_checkbox').val(ui.item.value);
						}
					});
					if(therapist_amount == 0){
						$(this).parent().parent().parent().find('.auto_employee').prop('disabled', true).hide();
						$(this).parent().parent().parent().parent().find('.reserve_checkbox').prop('checked', false).prop('disabled', true);
					}else{
						$(this).parent().parent().parent().find('.auto_employee').prop('disabled', false).show();
						$(this).parent().parent().parent().parent().find('.reserve_checkbox').prop('disabled', false);
					}
				});
				
				// FORCE DELETE
				$('.treatment_group .button.remove').unbind('click');
				$('.treatment_group .button.remove').click(function(){
					if(confirm(confirm_delete)){
						$(this).parent().parent().remove();
					}
				});
				current_product++;
			}	
		});
	});
}
function setGroupButtonPackage(){
	$('#group_form .button.package').click(function(){
		loading();
		customer = $(this).attr('index');
		$.ajax({
			type	:	"POST",
			url		:	path+"ajax_group.php",
			data	:	{command: "getGroupPackage", customer: customer},
			dataType:	"json",
			success	:	function(data){
				unload();
				clearWizard();
				$('.customer'+customer+' .customer_drop_zone').append(data.show);
				setNumberOnly();
				$('.customer'+customer+' .customer_drop_zone .auto_employee').autocomplete({
					source: path+"ajax_autocomplete.php?type=all",
					minLength: 1,
					autoFocus: true
				});
				current_product = customer;
				
				current_product = data.sub_index;
				
				$('.customer'+customer+' .package_select'+current_product).change(function(){
					loading();
					obj = $(this);
					package_detail = obj.parent().parent().parent().parent().parent().find('.package_detail');
					
					product_id = $(this).val();
					index_id = $(this).attr('index_id');
					customer = $(this).attr('customer');

					$.ajax({
						type	:	"POST",
						url		:	path+"ajax_group.php",
						data	:	{command: "getGroupPackageDetail", customer: customer, product_id: product_id, index_id: index_id},
						success	:	function(data){
							unload();
							package_detail.html(data).fadeIn();
							package_detail.find('.auto_employee').autocomplete({
								source: path+"ajax_autocomplete.php?type=all",
								minLength: 1,
								autoFocus: true,
								close:	function(){
									sub_index = $(this).attr("sub_index");
									therapist_amount = parseInt($(this).attr('therapist'));
									if(therapist_amount > 1){
										child_index = $(this).parent().parent().index();
									}else{
										child_index = $(this).parent().parent().parent().parent().index();
									}
									if(child_index == 0){
										val = $(this).val();
										if(sub_index == 1){
											if(therapist_amount > 1){
												$(this).parent().parent().parent().parent().parent().find('.auto_employee').filter('[index_type=odd]').val(val);
											}else{
												$(this).parent().parent().parent().parent().parent().find('.auto_employee').not(':eq(0)').val(val);
											}
										}else{
										}
									}
								},
								select:	function(event, ui){
									$(this).parent().parent().parent().parent().parent().find('.reserve_therapist .reserve_checkbox').val(ui.item.value);
								}
							});
						}
					});
				});

				// FORCE DELETE
				$('.package_group .button.remove').unbind('click');
				$('.package_group .button.remove').click(function(){
					if(confirm(confirm_delete)){
						$(this).parent().parent().parent().remove();
					}
				});

				current_product++;
			}
		});
	});
}
function wizardGroupSuccess(){
	loading();
	vars = $('#group_form').serialize();
	$.ajax({
		type		:	"POST",
		data		:	{command: "wizard", vars: vars},
		dataType	:	"json",
		url			:	"ajax_group.php",
		error		:	function(data){
			console.log(data);
		},
		success		:	function(data){
			unload();
			//$('#first').html(data.debug);
			// console.log(data);
			
			$('.wizardzone').html(data.show).fadeIn(200).removeClass('loading black');
			$('.button_no_wizard').click(function(){
				$.ajax({
					type	:	"POST",
					url		:	"ajax.php",
					data	:	{command: "clearSkipAll"},
					success	:	function(data){
						clearWizard();
						$('button[name=submit_button]').prop('disabled', false);
					}
				});
			});
			if(!data.pass){
				$('button[name=submit_button]').prop('disabled', true);
			}else{
				$('button[name=submit_button]').prop('disabled', false);
			}
		}
	});
	$('#auto_therapist_wizard').modal('hide');
}
function checkTherapistCode(){
	vars = $('form').serialize();
	console.log(vars);
	$.ajax({
		type	:	"POST",
		url		:	"ajax_new.php",
		data	:	{command: "checkTherapistCode", vars: vars},
		success	:	function(data){
			alert(data);
		}
	});
}
function setDeleteTimeButton(){
	$('.therapist_status_button').click(function(){
		if(confirm("ปรับสถานะหมอคนนี้?")){
			id_queue = $(this).attr('id_queue');
			//alert(id_queue);
			$.ajax({
				type	:	"POST",
				url		:	"ajax.php",
				data	:	{command: "change_status", id_queue: id_queue},
				success	:	function(data){
					// getAdminTimePage();
					location.reload();
				}
			});
		}
	});
	$('.delete_time').click(function(){
		if(confirm("ต้องการที่จะลบ time อันนี้แน่นะ?")){
			type = $(this).attr('type');
			use_time_id = $(this).attr('use_time_id');
			$.ajax({
				type	:	"POST",
				url		:	"ajax.php",
				data	:	{command: "delete_time_id", type: type, use_time_id: use_time_id},
				success	:	function(data){
					getAdminTimePage();
				}
			});
		}
	});
}
function refreshTime(){
	vars = $('#filter_form').serializeArray();
	$.ajax({
		type		:	"POST",
		url			:	"ajax.php",
		dataType	:	"json",
		data		:	vars,
		beforeSend	:	function(){
			//$('.dropzone').html("<div class='loading black'></div>");
		},
		success		:	function(data){
			$('.dropzone').html(data.show);
			setBlockTimeButton();
			setTherapistCheckInButton();
			setHoverTimeBlock();
			setDeleteTimeButton();
		}
	});
}
function getAdminTimePage(){
	$.ajax({
		type	:	"POST",
		url		:	"ajax_new.php",
		data	:	{command: "admin_time", type: "full"},
		dataType:	"json",
		success	:	function(data){
			console.log(data);
			$('#admin_time .dropzone').html(data.show);
			setBlockTimeButton();
			setTherapistCheckInButton();
			setHoverTimeBlock();
			setDeleteTimeButton();
			
			token = data.token;
			$('#admin_time .dropzone .update_time .time').html(data.update);
			
			//ticker
			theight = $(".table.time-table").height() - 28;
			$('.time_block_container .ticker').css({"height": theight, "left": data.ticker_xpos+"%"});
		}
	});
}
function setDeleteWorktimeButton(){
	$('.delete_worktime_button').click(function(){
		if(remark = prompt('ต้องการที่จะลบ score/cross อันนี้แน่นะ?')){
			worktime_log_id = $(this).attr('worktime_log_id');
			type = $(this).attr('type');
			$.ajax({
				type	:	"POST",
				url		:	"ajax.php",
				data	:	{command: "delete_worktime_log_id", worktime_log_id: worktime_log_id, type: type, remark: remark},
				success	:	function(data){
					$.ajax({
						type	:	"POST",
						url		:	"ajax_new.php",
						data	:	{command: "queue_human", type: "full"},
						dataType:	"json",
						success	:	function(data){
							// console.log(data);
							$('#queue_human .dropzone').html(data.show);
							setDeleteWorktimeButton();
						}
					});
					token = data.token;
					$('#queue_human .update_time .time').html(data.update);
					
				}
			});
		}
	});
}
function setHover(){
	cursor_x = event.pageX + 10;
	cursor_y = event.pageY + 10;
	$('.hover').css({top: cursor_y, left: cursor_x});
}
function setHoverTimeBlock(){
	$('.time_block').mousemove(function(event){
		//console.log(event);
		cursor_x = event.pageX + 10;
		cursor_y = event.pageY + 10;
		$('#cursor_hover').css({top: cursor_y, left: cursor_x});
	});
	$('.time_block_bar').hover(
	function(){
		remark = $(this).parent().attr('remark');
		type = $(this).parent().attr('block_type');
		start = $(this).parent().find('.start').text();
		end = $(this).parent().find('.end').text();
		additional = $(this).parent().find('.additional').html();
		if(remark != ""){
			text = remark+" : "+start+" - "+end;
		}else{
			text = type+" : "+start+" - "+end;
		}

		if(additional != undefined){
			// HOVER ADDITIONAL DATA
			additional = '<div class="additional-hover">'+additional+'</div>';
		}else{
			additional = '';
		}

		if(text != ""){
			$('#cursor_hover').stop(1, 1).addClass(type).fadeIn(200).html(text+additional);
		}
	},
	function(){
		$('#cursor_hover').stop(1, 1).fadeOut(200, function(){
			$(this).removeClass();
		});
	});
}
function setCardInput(){
	//scanner //code //card //card_info
	$('.card_input').unbind('change');
	$('.card_input').keyup(function(){
		card_input = $(this);
		code = $(this).attr('code');
		value = $(this).val();
		net_balance = $(this).parent().parent().find('.net_balance');
		card_box = $(this).parent().parent().parent().parent();
		$.ajax({
			url		:	"ajax.php",
			type	:	"POST",
			dataType:	"json",
			data	:	{command: "checkbalance", code: code, value: value},
			success	:	function(data){
				//console.log(data.left);
				if(data.pass){
					card_box.addClass('usecard').removeClass('insufficient');
					
				}else{
					card_input.val("");
					card_box.addClass('insufficient').removeClass('usecard');
				}
				net_balance.html(data.left);
				newRealtimeCalculation();
			}
		});
	});
}
function checkCardBalance(){
	$('.card_box').each(function(){
		card_no = $(this).attr('card_no');
		card_input = $(this).find('.card_input');
		code = card_input.attr('code');
		value = card_input.val();
		$.ajax({
			url		:	"ajax.php",
			type	:	"POST",
			dataType:	"json",
			data	:	{command: "checkbalance", code: code, value: value, card_no: card_no},
			success	:	function(data){
				card_box = $('.card_box[card_no='+data.card_no+']');
				if(data.pass){
					card_box.addClass('usecard').removeClass('insufficient');
				}else{
					card_box.find('.card_input').val("");
					card_box.addClass('insufficient').removeClass('usecard');
				};
				card_box.find('.net_balance').html(data.left);
				newRealtimeCalculation();
			}
		});
	});
}
function doVoucherBoxClose(){
	$('.voucher_box .delete').unbind('click');
	$('.voucher_box .delete').click(function(){
		if(confirm("Remove this voucher?")){
			parent = $(this).parent();
			voucher = parent.attr('voucher');
			removeCardVoucherInside(voucher, parent);

			// NEW ERROR BOX
			$('.voucher_message.error').hide();
		}
	});
}
function removeAllScanCardVoucher(callback){
	$('.voucher_box').each(function(){
		parent = $(this);
		code = $(this).attr('voucher');
		removeCardVoucherInside(code, parent, callback);
	});
}
function unlockGuide(){
	// $('.guide_commission_percent, .guide_commission_name').val("").prop('disabled', false).prop('readonly', false);
}
function lockDiscount(){
	// LOCK DISCOUNT
	$('.discount_input, .new_price_input, .discount_percent_input').prop('disabled', true);
}
function unlockDiscount(){
	// UNLOCK DISCOUNT
	$('.discount_input, .new_price_input, .discount_percent_input').prop('disabled', false);
}
function removeCardVoucherInside(code, parent, callback){
	// REMOVE PRODUCT MARK
	clearProductMark();

	// RECEIPT TYPE
	receipt_type = $('input[name=receipt_type]').val();

	// REMOVE
	parent.remove();

	// CHECK
	total_scanned_voucher = $('.voucher_box').length;
	if(total_scanned_voucher == 0){
		unlockDiscount();

		// ENABLE TIER DISCOUNT
		turnTierDiscount(true);
	}

	$.ajax({
		type	:	"POST",
		data	:	{command: "deleteVoucher", voucher:code},
		dataType:	"json",
		url		:	"ajax.php",
		success	:	function(data){
			// console.log("doVoucherBoxClose");
			$('#payment_sum, #payment').show();
			$('#payment_sum2').hide();
			if(data.total_discount >= 0){
				// ลดทั้งบิล
				$('.discount_amount_input').val(data.total_discount);
			}
			// if(data.total_discount == 0){
			// 	$('.discount_amount_input').prop('readonly', false);
			// }
			
			// CALCULATE
			if(receipt_type == 'product'){
				$('.sub_discount, .sub_percent_discount, .discount_percent_input').val('').prop('readonly', false);
				$('.quantity').prop('readonly', false);
				realtimeCalculation(callback);
			}else{
				getOrderList();
				newRealtimeCalculation();
			}
		}
	});
}
function getOrderList(type, callback){
	// AJAX RELOAD
	loading();
	vars = $('.payment_form').serialize();
	$.ajax({
		url		:	"ajax.php",
		data	:	{command: "fetch_order_detail", vars:vars},
		dataType:	"json",
		type	:	"POST",
		error	:	function(data){
			console.log("ERROR : getOrderList");
			// console.log(data);
			realtimeCalculation();
			unload();
		},
		success	:	function(data){
			console.log("getOrderList : "+data.status);
			unload();
			if(data.status == "reject_all_voucher"){
				// ล้างค่า voucher ให้หมด
				$('#scanbox-voucher').html(data.display_error);

				// DELETE ALL VOUCHERS
				$.ajax({
					type	:	"POST",
					data	:	{command: "deleteAllVoucher"},
					url		:	"ajax.php",
					success	:	function(data){
						$('.voucher_box').fadeOut(200).remove();
						getOrderList();
					}
				});
			}else{
				$('.main_content .dropzone').html(data.show);
				setLiveCal();
			}
			if(data.is_percent_discount){
				$('#discount').fadeOut(200);
			}else{
				$('#discount').fadeIn(200);
			}

			if(type == "cashcard"){
				// DISABLED all Discount Inputs
				$('.discount_input, .new_price_input').val("").attr('disabled', 'disabled');
			}
	
			// CALLBACK
			if(callback){
				callback();
				autoEmployee();
			}else{
				newRealtimeCalculation();
			}
		}
	});
}
function doCloseBox(){
	$('a.delete').click(function(){
		scancode = $(this).parent().find('.scancode').val();
		$.ajax({
			type	:	"POST",
			data	:	{command: "deleteScanPayment", scancode:scancode},
			url		:	"ajax.php",
			success	:	function(data){
				
			}
		});
		$(this).parent().fadeOut(200, function(){
			$(this).remove();
			if($('#new_payment_form').length){
				newRealtimeCalculation();
			};
			if($('#cashier_form').length){
				realtimeCalculation();
			};
		});
	});
}
function doCardBoxClose(){
	$('.card_box .delete').unbind('click');
	$('.card_box .delete').click(function(){
		if(confirm("Remove this card?")){
			scancode = $(this).parent().find('.scancode').val();
			$.ajax({
				type	:	"POST",
				data	:	{command: "deleteScanPayment", scancode:scancode},
				url		:	"ajax.php",
				success	:	function(data){
					
				}
			});

			card_no = $(this).attr('card_no');
			parent = $(this).parent();
			card_input = parent.find('.card_input');
			$.ajax({
				type	:	"POST",
				data	:	{command: "deletecard", card_no:card_no},
				url		:	"ajax.php",
				success	:	function(data){
					is_foc = $('.card_box[card_no='+card_no+']').hasClass('foc_card');
					if(is_foc){
						$('.discount_percent_input').val("");
						$('input[name=foc_amount]').val("");
						$('input[name=special_discount]').val("");
					}
					console.log("doCardBoxClose");
					card_input.val("");
					parent.fadeOut(200, function(){
						newRealtimeCalculation();
					}).remove();
					
					$('#payment_sum, #payment').show();
					$('#payment_sum2').hide();

					// ENABLE DISCOUNT INPUT
					card_left = $('#scanbox-card .card_box').length;
					if(card_left <= 0){
						$('.discount_input, .new_price_input').removeAttr('disabled');
						$('#payment_type_select .sub_group').fadeIn(200);
					}
				}
			});
		}else{
		}
	});
}
function setLiveCal(){
	$('#new_payment_form .live_cal').on('change', function(){
		newRealtimeCalculation();
	});
	$('#cashier_form .live_cal').on('change', function(){
		realtimeCalculation();
	});
}

function reApplyVoucher(){
	// HIDE ERROR BOX
	$('.voucher_message.error').hide();

	var scanned_code = new Array;

	$('.voucher_box.pass').each(function(){
		voucher_code = $(this).attr('voucher');
		scanned_code.push(voucher_code);
		// console.log('reApplyVoucher : '+voucher_code);
	});
	// getVoucher(voucher_code);
	removeAllScanCardVoucher(function(){
		scanned_code.forEach(function (voucher_code, index) {
			// console.log(item, index);
			getVoucher(voucher_code);
		});
	});
}
function getVoucher(code, type){
	// VOUCHER
	vars = $('.payment_form').serialize();
	receipt_type = $('input[name=receipt_type]').val();
	loading();
	$.ajax({
		url		:	"ajax.php",
		data	:	{command: "voucher_payment", code:code, vars:vars, type: type},
		dataType:	"json",
		type	:	"POST",
		success	:	function(data){
			// console.log('getVoucher : '+receipt_type);
			// console.log(data);
			unload();
			unlockGuide();
			unlockDiscount();

			// VOUCHER
			$('#scanbox-voucher').html(data.show);
			doVoucherBoxClose();

			// DO MARK
			doProductMark(data.property);

			// ฟังก์ชั่นใหม่
			if(data.pass != false){
				// CALLBACK FUNCTION
				callback = function(){
					// AUTO DISCOUNT
					if(receipt_type == "product"){
						// PRODUCT
						// CHECK PRODUCT ID FIRST
						if(data.property.product_id){
							$('.product_group[product_id]').each(function(){
								input_product_id = $(this).attr('product_id');
								quantity = $(this).find('.quantity').val();
								if($.inArray(input_product_id, data.property.product_id) !== -1){
									// PARENT
									if(data.property.discount_percent > 0){
										$(this).find('.sub_percent_discount').val(data.property.discount_percent);
									}else if(data.property.discount_amount > 0){
										// MULTIPLY
										if(data.property.is_discount_per_item){
											discount = quantity * data.property.discount_amount;
										}else{
											discount = data.property.discount_amount;
										}
										$(this).find('.sub_discount').val(discount);
									}
									// MAKE READONLY
									$(this).find('.quantity, .sub_discount, .sub_percent_discount, .discount_percent_input').prop('readonly', true)
								}
							});
						}
						
						// CHECK CATEGORY ID SECOND
						if(data.property.category_id){
							$('.product_group[category_id]').each(function(){
								input_category_id = $(this).attr('category_id');
								quantity = $(this).find('.quantity').val();
								if($.inArray(input_category_id, data.property.category_id) !== -1){
									// PARENT
									if(data.property.discount_percent > 0){
										$(this).find('.sub_percent_discount').val(data.property.discount_percent);
									}else if(data.property.discount_amount > 0){
										$(this).find('.sub_discount').val(data.property.discount_amount);
									}
									// MAKE READONLY
									$(this).find('.quantity, .sub_discount, .sub_percent_discount, .discount_percent_input').prop('readonly', true)
								}
							});
						}

						// CHECK PRODUCT BRAND ID
						if(data.property.product_brand_id){
							$('.product_group[product_brand_id]').each(function(){
								input_product_brand_id = $(this).attr('product_brand_id');
								quantity = $(this).find('.quantity').val();
								if($.inArray(input_product_brand_id, data.property.product_brand_id) !== -1){
									// PARENT
									if(data.property.discount_percent > 0){
										$(this).find('.sub_percent_discount').val(data.property.discount_percent);
									}else if(data.property.discount_amount > 0){
										$(this).find('.sub_discount').val(data.property.discount_amount);
									}
									// MAKE READONLY
									$(this).find('.quantity, .sub_discount, .sub_percent_discount, .discount_percent_input').prop('readonly', true)
								}
							});
						}

						// REF RECEIPT NO
						if(data.property.ref_receipt_no){
							$('select[name=receipt_no]').val(data.property.ref_receipt_no);
						}

						// DISCOUNT AMOUNT
						if(data.total_discount >= 0){
							// ลดทั้งบิล
							$('.discount_amount_input').val(data.total_discount).prop('readonly', true);
						}

						// FALLBACK
						if(!data.property.product_id && !data.property.category_id  && !data.property.product_brand_id){
							// NO ID SET
							// DISABLED ALL DISCOUNT RELATE INPUT
							$('.discount_percent_input').val(data.property.discount_percent).prop('readonly', true);
							$('.sub_discount').prop('readonly', true);
							$('.sub_percent_discount').prop('readonly', true);
						}
						realtimeCalculation();
					}else{
						// SERVICE
						discount_fill = false;
						if((data.property.treatment_id != undefined || data.property.package_id != undefined) && data.property.discount_percent){
							// DISCOUNT SOME ITEMS / USE AJAX
							
						}else{
							if(data.property.discount_percent){
								// DISCOUNT ALL SUB ITEM
								$('.order_box').each(function(){
									if(discount_fill != true){
										$(this).find('.sub_discount').val(data.property.discount_percent);
										discount_fill = true;
									}else{
										// $(this).find('.sub_discount').prop('disabled', true);
									}
								});
								if(discount_fill == true){
									$('.sub_discount').prop('readonly', true);
								}
							}else if(data.total_discount){
								// ลดทั้งบิล
								$('.discount_amount_input').val(data.total_discount).prop('readonly', true);
							}else if(data.property.discount_step_percent){
								// STEP DISCOUNT / USE MAIN DISCOUNT PERCENT INPUT
								$('.discount_percent_input, .sub_discount, .new_price_input').prop('readonly', true);
							}
						}
						newRealtimeCalculation();
					}

					if(data.guide.guide_id){
						// GUIDE
						$('.guide_commission_percent').val(data.guide.new_commission_percent_spa).prop('readonly', true);
						$('.guide_commission_name').val(data.guide.full_name).prop('readonly', true);
						
						guideRequireSalesperson();
					}
				}
				if(receipt_type == 'service'){
					getOrderList('', callback);
				}else if(receipt_type == 'product'){
					callback();
				}
			}
		}
	});
}
function doProductMark(voucherProperty){
	var key_to_check_array = ['product_id', 'category_id', 'product_brand_id'];

	key_to_check_array.forEach(function(value, index){
		if(voucherProperty[value] != null || voucherProperty[value] != undefined){
			$('.product_group').each(function(){
				key_to_check = $(this).attr(value);
				if($.inArray(key_to_check, voucherProperty[value]) !== -1){
					// MATCH
					$(this).find('.product-name').append('<i class="product-mark fas fa-check fa-2x green"></i>');
				}else{
					// NOT MATCH
					$(this).find('.product-name').append('<i class="product-mark fas fa-times fa-2x red"></i>');
				}
			});
		}
	});
}
function clearProductMark(){
	$('.product-mark').remove();
}

function guideRequireSalesperson(){
	// MAKE SALESPERSON FIELD AS REQUIRED
	message = 'หากมี Guide ต้องสแกนโค้ดของ Cashier คนที่รับลูกค้า';
	$('input[name=sale_user_id]').addClass('require').attr('type', 'text');

	getModal(message);
}

/**
 * doQuickSummary
 * สำหรับ Quick Booking
 */
function doQuickSummary(){
	is_quick = $('input[name=quick_booking]').val();
	if(is_quick){
		vars = $('#quick-booking-form').serialize();
		$.ajax({
			type	:	"POST",
			url		:	"ajax.php",
			data	:	{command: "calculateQuickBooking", vars: vars},
			dataType:	"json",
			success	:	function(data){
				// DISPLAY SUMMARY
				$('#payment_sum .payment_total .value').text(data.grand_total);
				$('#payment_sum .payment_paid .value').text(data.paid);
				$('#payment_sum .payment_balance .value').text(data.balance);

				// FOR WMPAY DEPOSIT
				full_deposit_amount_exist = $('input[name=full_deposit_amount]').length;
				if(full_deposit_amount_exist){
					$('.full_deposit.amount').html($.number(data.grand_total));
					$('.partial_deposit.amount').html($.number(Math.ceil(data.grand_total / 2)));
					$('#quick_payment_type input[name=full_deposit_amount]').val(data.grand_total);
				}

				// TOKEN SUMMARY
				$('#token_sum .token_total .value').text(data.sum_token);

				if(parseInt(data.balance) == 0){
					$('#payment_sum .padding').css("background-color","RGBA(0, 255, 0, 0.3)");
				}else{
					$('#payment_sum .padding').css("background-color","RGBA(255, 0, 0, 0.3)");
				}
			}
		});
	}
}

/**
 * ใช้เปิด/ปิด Tier Discount
 * @param {string} type 
 */
function turnTierDiscount(type){
	if(type){
		tier_discount = $('.tier_percent_discount').attr('data-tier-discount');
		$('.tier-discount-value').removeClass('strikethrough');
		$('.tier_percent_discount').val(tier_discount).prop('disabled', false);

		window.tier_discount_status = true;
	}else{
		$('.tier-discount-value').addClass('strikethrough');
		$('.tier_percent_discount').val(0).prop('disabled', true);
		if(window.tier_discount_status == true){
			$('.discount_amount_input').val(0);
		}
		window.tier_discount_status = false;
	}
}

/**
 * สำหรับเซ็ต script ที่เกี่ยวกับ submit payment form
 */
function setPaymentPage(){
	console.log('setPaymentPage();');
	// PROMOTION BUTTON
	$('.get_promotion_button, input[name=search_promotion]').click(function(){
		$('.promotion_box').fadeIn(100);
	});
	$('.use_promotion_button').click(function(){
		code = $(this).attr('code');
		getVoucher(code, 'promotion');
	});
	$('.promotion_box .delete').click(function(){
		$('.promotion_box').fadeOut(100);
	});

	// PROMOTION LIVE SEARCH
	$('input[name=search_promotion]').keyup(function(){
		// Retrieve the input field text and reset the count to zero
		var filter = $(this).val(), count = 0;

		// Loop through the comment list
		$(".promotion_box .promotion").each(function(){

			// If the list item does not contain the text phrase fade it out
			if ($(this).text().search(new RegExp(filter, "i")) < 0) {
				$(this).fadeOut(100);

			// Show the list item if the phrase matches and increase the count by 1
			} else {
				$(this).show();
				count++;
			}
		});

		// Update the count
		var numberItems = count;
		$(".get_promotion_button .badge").text(count);
	});

	// REDEEM VOUCHER IN CASHIER
	$('button[name=redeem-voucher]').click(function(){
		// CLEAR
		$('#scan-message').html('');

		current_payment_index = $('.sub_group').length;
		next_payment_index = current_payment_index + 1;
		$('.card_status').remove();
		to_pay = $('input[name=payment_total]').val();

		code = $(this).parent().find('input[name=encrypt_voucher_code]').val();
		$.ajax({
			url		:	"ajax.php",
			data	:	{command: "qrcode_payment", code: code, to_pay: to_pay, index: next_payment_index},
			dataType:	"json",
			type	:	"POST",
			success	:	function(data){
				if(!data.status){
					// THAI
					$('#scan-message').html(data.show);
				}else if(data.type == 'encrypt_voucher'){
					getVoucher(code);
				}else{
					$('#scan-message').html('<div class="announce error mini box">ใช้ได้แต่ encrypt voucher code เท่านั้น</div>');
				}
			}	
		});
	});

	//qrcode listener
	$(window).scannerDetection({
		onError		:	function(data){
			//alert("error");	
		},
		onComplete	:	function(data){
			// CLEAR
			$('#scan-message').html('');

			current_payment_index = $('.sub_group').length;
			next_payment_index = current_payment_index + 1;
			// console.log('scan code');
			$('.card_status').remove();
			to_pay = $('input[name=payment_total]').val();
			code = data;

			// PASSING TO SCAN CLASS
			var Scan = new ScanAction(code);

			// console.log('page : '+page);
			// console.log('onsen_page : '+onsen_page);
			// console.log('receipt_type : '+receipt_type);

			// CHECK TYPE
			// QR CASHCARD 
			$.ajax({
				url		:	"ajax.php",
				data	:	{command: "qrcode_payment", code: code, to_pay: to_pay, index: next_payment_index},
				dataType:	"json",
				type	:	"POST",
				success	:	function(data){
					if(!data.status){
						// THAI
						$('#scan-message').html(data.show);
					}else{
						// USE SCAN CLASS
						switch(data.type){
							case "member":
								if(data.status){
									// DO MEMBER LOGIN
									Scan.member(data.return);
								}
								break;
							case "booking":
							case "onsen_rfid":
							case "onsen_keychain":
							case "onsen_bag":
								Scan[data.type](data);
								break;
							default:
								// NOT PRODUCT
								if(data.type == 'creditcard'){
									Scan.creditcard(data);
								}

								// CHECK PAGE
								if(data.type == 'product' && onsen_page == 'onsen_bar'){
									loadRFID(data.code);
								}
								
								// PRODUCT GOES HERE
								if(receipt_type == 'product'){
									// PRODUCT
									Scan.product(data);
								}else if(receipt_type == 'service'){
									// SERVICE
									Scan.service(data);
								}
								break;
						}
					}
				}	
			});
		}
	});
	
	// normal code
	newRealtimeCalculation();
	$('#payment_sum_group').mouseover(function(){
		checkTransferDeposit();
	});
	/**
	 * On Cashier Submit Payment Page
	 */
	$('#new_payment_form .submit_payment').click(function(){
		// NEW SUBMIT TYPE BUTTON
		$('input[name=submit_type').val($(this).val());

		payment_button = $(this);

		checkCardBalance();
		pass = requireCheck();
		if(pass){
			vars = $('#new_payment_form').serialize();

			payment_button.prop('disabled', true);
			$.ajax({
				type		:	"POST",
				url			:	"ajax_new.php?command=calculate",
				data		:	vars,
				dataType	:	"json",
				error		:	function(){
					alert("There is something wrong with the system, please try again.");
					payment_button.prop('disabled', false);
					return false;
				},
				success		:	function(data){
					payment_button.prop('disabled', false);
					if(data.pass === false){
						alert(data.message);
						if(data.status == 'voucher_status_not_ready'){
							location.reload();
						}
						return false;
					}
					// console.log("------------------------------");
					// console.log(data);
					if(parseInt(data.paid) == 0 && (parseInt(data.balance) == 0 || parseInt(data.foc.balance) == 0)){
						if(data.use_inventory || data.ref_receipt_no != ""){
							if(confirm("Complete the reservation?")){
								$('#new_payment_form').submit();
								return true;
							}else{
								return false;
							}
						}else{
							alert("Paid can not be 0");
							return false;
						}
					}else if(parseInt(data.balance) == 0){
						if(confirm("Complete the reservation?")){
							$('#new_payment_form').submit();
							return true;
						}else{
							return false;
						}
					}else if(parseInt(data.foc.balance) == 0){
						if(confirm("Complete the reservation?")){
							$('#new_payment_form').submit();
							return true;
						}else{
							return false;
						}
					}else{
						alert("Customer must fully paid for this reservation.");
						return false;
					}
				}
			});
		}
		return false;
	});
}